export const IMAGE_FILE_TYPES = [
	'image/jpeg',
	'image/png',
	'image/webp',
	'image/gif',
]
export const MAX_SIZE_MB = 5

export const examTabList = ['rookie', 'semi', 'tour']
